module.exports = __webpack_public_path__ + "assets/8b37b3b78d33883d7c0e9e4df2f5d2fb.jpg";